// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"835":"4369fb50","886":"c36c0b32","939":"95ab75e3"}[chunkId] + ".chunk.js";
};